import { t } from '@moovly/i18n';
import { ToggleItem, Toggles } from '@moovly/ui';
import * as React from 'react';

interface AnalyticsFilterProps {
  months: number;
  onSelectMonths: (months: number) => void;
}
const AnalyticsFilter: React.FC<AnalyticsFilterProps> = ({ months, onSelectMonths }) => {
  const handleSelectMonths = React.useCallback((m: number) => () => onSelectMonths(m), [onSelectMonths]);
  return (
    <>
      <Toggles>
        <ToggleItem value="this-month" onClick={handleSelectMonths(1)} active={months === 1}>
          {t('dashboard.filters.thisMonth')}
        </ToggleItem>
        <ToggleItem value="past-3-months" onClick={handleSelectMonths(3)} active={months === 3}>
          {t('dashboard.filters.past3Months')}
        </ToggleItem>
        <ToggleItem value="past-year" onClick={handleSelectMonths(12)} active={months === 12}>
          {t('dashboard.filters.pastYear')}
        </ToggleItem>
      </Toggles>
    </>
  );
};

export default AnalyticsFilter;
